/*
* @Author: liulei
* @Date: 2018-11-08 10:41:08
 * @Last Modified by: liulei
 * @Last Modified time: 2020-06-24 15:47:12
*/

const userdomain = process.env.REACT_APP_API_INTERFACE + '/automobile/auto/gateway';
const kfDomain = process.env.REACT_APP_API_KFINTERFACE + '/auto/gateway';
let domain = (localStorage.getItem('systemSource') === 'kf') ? kfDomain : userdomain;
console.log('domain', domain)
const userApi = process.env.REACT_APP_API_INTERFACE + '/automobile/api/ins-app-user';
console.log('userApi', userApi)

const staffCarDomain = process.env.REACT_APP_API_INTERFACE + '/employee/appoint';

// 分享接口
// export const ShareAddress = process.env.REACT_APP_API_HOST + "/apis/c2c/user/v1/wx/share/cs"; //
export const ShareAddress = domain + "/v1/wx/jsapi/verify"; //
export const CenterUrl = process.env.REACT_APP_API_CENTER; // 获取省接口
/*获取地址接口*/

export const LatitudeToIp = domain + "/v1/area/city/" //经纬度转城市
export const CityInfo = domain + "/v1/area/cityInfo" //根据城市获取投保信息
export const Address_province = domain + "/v1/area/provinces"; // 获取省接口
export const Address_city = domain + "/v1/area/city"; // 获取省下面的市接口
export const Phonde_code = domain + "/v1/order/getVerifyCode"; // 获取验证码接口
export const Phone_verify = domain + "/v1/doVerify";// 校验短信验证码接口
export const OFFER_INTERFACE = domain + '/v1/getHistoryOrder'; //立即报价接口
export const PrepareUpdate = domain + '/v1/prepareUpdate'; //修改订单接口
export const QueryProvinceByUserId = domain + '/v1/area/queryProvinceByUserId'; //根据用户id获取对应的地区


/*OCR识别证件接口*/
export const OcrIdentify_IDcard = domain + "/v1/ocr/idcard";
export const OcrIdentify_vehicle = domain + "/v1/ocr/vehicle";

/*请求车型*/
export const GetCarBrand = domain + "/v1/vehicle/all/brands";
export const GetCarSeries = domain + "/v1/vehicle/families";
export const GetCarInfo = domain + "/v1/vehicle/brand/family";
export const GetCarVinInfo = domain + "/v1/vehicle/vin";
export const GetCarVendor = domain + "/v1/vehicle/popular/brand/vendor";
export const GetCarInfoByDisplacementRemark = domain + "/v1/vehicle/displacement/remark";
export const SearchCarInfo = domain + "v1/vehicle/integrate/query";
export const ChangeLicensePlateNo = domain + '/v1/vehicle/licensePlateNo';

/*立即报价*/
export const OfferPrice = domain + "/v1/quotation";

/*确认支付*/
export const ConfirmPay = domain + "/v1/confirmPayment";
export const KinematicPrice = domain + "/v1/coverage/choice";
export const ConfirmationQuotation = domain + "/v1/quote/message";
export const HandSignUpload = domain + "/v1/ocr/handsign";
export const SubmitForm = domain + "/v1/health";

/*代理人登录*/
export const AgentLogin = domain + "/v1/doLogin";

/*商业险 交强险 */
export const InsuranceInfo = domain + "/v1/agreement/floating/message";

//特别内容
export const SpecialInfo = domain + "/v1/agreement/specialAgt";

// 重新支付
export const RepayInfo = domain + "/v1/confirmPaymentByOrderId";
//调取收银台接口
export const PayMoney = process.env.REACT_APP_PAY_MONEY + "EmotorInterface/PaymentServlet"

//广东地区投保人短信验证码发送接口
export const ApplicantCheck = domain + "/v1/applicantCheck";
//广东地区支付申请接口
export const PaymentApplication = domain + "/v1/paymentApplication";
//广东地区短链接发送验证码
export const SendPhoneCheckMessage = domain + "/v1/sendPhoneCheckMessage";
//广东地区短链接校验验证码
export const VerifyPhoneCheckMessage = domain + "/v1/verifyPhoneCheckMessage";

export const CodeCheck = domain + "/v1/verifyUserIdentityByCode";
export const CodeCheckApply = domain + "/v1/paymentApplication";

//校验登录状态
export const AgentVerify = domain + "/v1/agentVerify";

//获取调起收银台所需信息
export const PayParamGet = domain + "/v1/confirmOrder";

//获取调起收银台所需信息
export const QueryPaymentRequestByOrderId = domain + "/v1/queryPaymentRequestByOrderId";

// cdn图片接口
export const imageBaseUrl = "https://img01.az.jd.com/ins-automobile-m/image/"

//获取pdf接口
export const GetPdfInfo = domain + "/v1/agreement/downloadPdf";

//判断渠道类型
export const CheckPartnerRefType = domain + "/v1/checkPartnerRefType";

// export const OrderDetail = domain + '/v1/queryOrderInfo';
// 修改接口不用携带token进行登录验证 
export const OrderDetail = domain + '/v1/query/queryOrderInfo';


//可回溯系统
//获取可回溯流水号(thirdTradeNo为订单号，没有可不填)
export const getInsureNo = domain + '/v1/recall/getInsureNo';

//小程序获取openId
export const getOpenIdUrl = domain + '/v1/user/openId';

//生成urlscheme
// export const getUrlSchemeUrl = process.env.REACT_APP_URLSCHEME;
//生成urlLink
export const getUrlSchemeUrl = process.env.REACT_APP_URLLINK;

//立即支付
export const payConfirmPayment = domain + '/v1/pay/confirmPayment';

// 用户中心登录
export const islogin = userApi + '/api/v2/checkWithAutoLogin';

//根据订单号生成二维码
export const getQrCode = domain + '/v1/qrCode/getQRCodeByOrderId';

//发送投保单及告知单通知短信
export const notificationSMS = domain + '/v1/notificationSMS';

//根据订单号查询保单号
export const queryPolicyNo = domain + '/v1/queryPolicyNo';

//客服立即报价接口(客服版进入insuranceInfo页面初始化调的这个接口)
export const CONSUMER_OFFER_INTERFACE = domain + '/v1/consumer/getHistoryOrder';

//发送待支付链接至投保人
export const sendUnpaidLink = `${domain}/v1/qrCode/sendPayUrl`;

// ------- 员工车预约投保 -------
// 活动期限校验 
export const appointCheck = staffCarDomain + '/appoint/check';
// export const appointCheck = process.env.REACT_APP_API_INTERFACE + '/staff/employee/appoint/appoint/check';

// 保存预约记录
export const apponitSave = staffCarDomain + '/appoint/save';

// 操作短信验证码发送
export const sendPhoneCheckMessage = domain + '/v1/sendPhoneCheckMessage';

// 通过订单号查询支付请求入参
export const queryPaymentRequestByOrderId = domain + '/v1/queryPaymentRequestByOrderId';

// 获取支付二维码
export const getPayQrCode = domain + '/v1/getPayQrCode';
export const getQuickPayQrCode = domain + '/v1/pay/getPayUrl';

//通过短信验证码验证操作人
export const verifyOperator = domain + '/v1/signature/verify';
//电子投保单相关接口(获取电子投保单&实名链接)
export const getProposalLink = `${domain}/v1/eProposal/getProposalLink`;

//获取支付链接的接口(支付宝二维码、pos码)
export const getPayLink = `${domain}/v1/pay/getPayUrl`;


// erp 登录网销项目接入   https://car-test.jdallianz.com/jk
export const isOrderLogin = process.env.REACT_APP_API_DOMAIN_NAME + '/ins-temp-m/api/user_new/api/v1/islogin'

//是否显示加载loading
export const isShowLoading = [
    ConfirmationQuotation,
    OFFER_INTERFACE,
    RepayInfo,
    Address_city,
    Address_province,
    GetCarBrand,
    GetCarSeries,
    GetCarInfo,
    GetCarVinInfo,
    GetCarVendor,
    GetCarInfoByDisplacementRemark,
    SearchCarInfo,
    ChangeLicensePlateNo,
    OfferPrice,
    ConfirmPay,
    PayParamGet,
    PrepareUpdate,
    CodeCheck,
    CONSUMER_OFFER_INTERFACE,
    HandSignUpload,
    sendUnpaidLink,
    getPayLink,
    queryPolicyNo,
    KinematicPrice,
    payConfirmPayment,
    isOrderLogin
]
